module.exports = __webpack_public_path__ + "static/media/loupe_white.af30d6ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/loupe_white.svg
// module id = 223
// module chunks = 0